import React, {useImperativeHandle, useRef} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonDialog
  from 'components/atoms/Editors/EditorMenuButtonDialog/EditorMenuButtonDialog.styles';
import CropFree from '@mui/icons-material/CropFree';
import {useRichTextEditorContext} from 'mui-tiptap';

const EditorMenuButtonDialog = React.forwardRef((props, ref) => {
  const {
    onClick,
    ...innerProps
  } = useComponentProps(props, 'EditorMenuButtonDialog');

  const innerRef = useRef(null);
  const editor = useRichTextEditorContext();

  useImperativeHandle(ref, () => innerRef.current);

  const handleClick = () => {
    onClick?.(editor);
  }

  return <StyledEditorMenuButtonDialog buttonRef={innerRef} {...innerProps}
                                       value="dialog"
                                       size="small"
                                       onClick={handleClick}
                                       tooltipLabel="Show dialog"
                                       tooltipShortcutKeys={['mod', 'Shift', 'O']}
                                       IconComponent={CropFree}/>
});

EditorMenuButtonDialog.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  onClick: PropTypes.func
};

export default EditorMenuButtonDialog;
